import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/signup";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/signup")({
  head: () => buildNoindexHead("Create Account", "/signup"),
  component: Page,
});
